module.exports = __webpack_public_path__ + "img/reset.011e86f0.svg";